import React from "react";
import { useParams, Routes, Route, Navigate } from "react-router-dom";
import { systemThemes } from "../themes/systemThemes";
import ThemeRenderer from "../components/ThemeRenderer";



export default function ThemePreview() {
  const { themeId } = useParams();

  const theme = systemThemes.find(t => t.id === themeId);

  if (!theme) return <div>Theme not found</div>;

  const pages = theme.theme.site.pages;
  const rTheme = theme.theme

  return (
    <div>
      {/* Layout Header + Navigation */}
      <ThemeRenderer 
        theme={rTheme}
        mode="preview"
      />

      {/* Child Page Routing */}
      <Routes>
        {/* Default redirect → first page (home) */}
        <Route
          path="/theme/{theme.id}"
          element={<Navigate to={`/${Object.keys(pages)[0]}`} replace />}
        />

        {/* Generate a route for each page */}
        {Object.values(pages).map(page => (
          <Route
            key={page.slug}
            path={page.slug}
            element={
              <div style={{ marginTop: "20px" }}>
                {page.blocks.map((block, i) => (
                  <ThemeRenderer.Block key={i} block={block} />
                ))}
              </div>
            }
          />
        ))}

      </Routes>
    </div>
  );
}

